export enum Model {
    BulkImport = 'bulkimport',
    CustomersSuppliersSettings = 'customerssupplierssettings',
    DepreciationSettings = 'depreciationsettings',
    QuestionnaireTemplate = 'questionnairetemplate',
    Connection = 'connection',
    CompanyAccess = 'companyaccess',
    GenericScenario = 'genericscenario',
    Invitation = 'invitation',
    Member = 'member',
    Organisation = 'organisation',
    OrganisationStatistics = 'organisationstatistics',
    OrganisationQuestion = 'organisationquestion',
    OrganisationRole = 'organisationrole',
    OrganisationHistory = 'organisationhistory',
    PersonalTaxSettings = 'personaltaxsettings',
    PersonalTaxSync = 'personaltaxsync',
    RagFile = 'ragfile',
    SharePointSite = 'sharepointsite',
    Subscription = 'subscription',
    ExportFileMerge = 'exportfilemerge',
    WaitingListEntry = 'waitinglistentry',
    Unknown = 'unknown',
    AnnualReportPrompt = 'annualreportprompt',
    VATImportSettings = 'vatimportsettings',
}
